import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

export default function MICApplication(props) {
  const { header } = props;

  return (
    <Fragment>
      <header className="application__mic--header">
        <div className="application__mic--header-container">
          <div className="application__mic--header-container-logo">
            <img src={header.img} alt="MIC 2022" />
          </div>

          <div className="application__mic--header-container-date">
            Final Deadline: September 17 ($995)
          </div>

          <div className="application__mic--header-container-button">
            <a href={header.link}>Apply Now</a>
          </div>
        </div>
      </header>

      <div className="application__mic--wrapper">
        <div className="application__mic--content">
          <article>
            <main className="application__mic">
              <section className="application__mic--intro">
                <p>
                  Since 2008, <em>Fast Company</em>’s Most Innovative Companies
                  has been the definitive source for recognizing the
                  organizations that are transforming industries and shaping
                  society. Last year, <em>Fast Company</em> recognized more than
                  400 organizations with this prestigious honor, from the
                  largest companies in the world to small startups with just a
                  few employees. With innovation more important than ever this
                  year, <em>Fast Company</em> is looking forward to recognizing
                  the organizations that are moving the world forward.
                </p>

                <p>
                  Every submission for the 2022 Most Innovative Companies will
                  be individually evaluated by a team of <em>Fast Company</em>{' '}
                  editors and reporters.
                </p>

                <div className="application__mic--intro-button">
                  <a href={header.link}>Apply Now</a>
                  <span>Final Deadline: September 17 ($995)</span>
                </div>
              </section>

              <section className="application__mic--why_apply">
                <h2>Why Apply</h2>

                <div className="application__mic--why_apply-grid">
                  <div className="application__mic--why_apply-grid-entry">
                    <div className="application__mic--why_apply-grid-entry-logo">
                      <img
                        src="https://assets.fastcompany.com/image/upload/v1624481705/MIC%202021/Group_78.svg"
                        alt="icon"
                      />
                    </div>

                    <div className="application__mic--why_apply-grid-entry-content">
                      <h3>Brand Exposure</h3>

                      <span>
                        Be seen and evaluated by <em>Fast Company</em> editors
                        and reporters
                      </span>
                    </div>
                  </div>

                  <div className="application__mic--why_apply-grid-entry">
                    <div className="application__mic--why_apply-grid-entry-logo">
                      <img
                        src="https://assets.fastcompany.com/image/upload/v1624481709/MIC%202021/fc-break-news-icon.svg"
                        alt="icon"
                      />
                    </div>

                    <div className="application__mic--why_apply-grid-entry-content">
                      <h3>Break News</h3>

                      <span>
                        Tell your organization’s story to the world for the
                        first time; highlight the success of teams within your
                        organization—or partners who’ve helped with your success
                      </span>
                    </div>
                  </div>

                  <div className="application__mic--why_apply-grid-entry">
                    <div className="application__mic--why_apply-grid-entry-logo">
                      <img
                        src="https://assets.fastcompany.com/image/upload/v1624481712/MIC%202021/icon-general_excellence-black_copy_2.svg"
                        alt="icon"
                      />
                    </div>

                    <div className="application__mic--why_apply-grid-entry-content">
                      <h3>Opportunities</h3>

                      <span>
                        Speaking engagements at <em>Fast Company</em> events and
                        exclusive invitations to influencer-only events
                      </span>
                    </div>
                  </div>

                  <div className="application__mic--why_apply-grid-entry">
                    <div className="application__mic--why_apply-grid-entry-logo">
                      <img
                        src="https://assets.fastcompany.com/image/upload/v1624481710/MIC%202021/icon-general_excellence-black.svg"
                        alt="icon"
                      />
                    </div>

                    <div className="application__mic--why_apply-grid-entry-content">
                      <h3>Visibility</h3>

                      <span>
                        Appear in the March/April 2022 issue of{' '}
                        <em>Fast Company</em> and on fastcompany.com
                      </span>
                    </div>
                  </div>

                  <div className="application__mic--why_apply-grid-entry">
                    <div className="application__mic--why_apply-grid-entry-logo">
                      <img
                        src="https://assets.fastcompany.com/image/upload/v1624481714/MIC%202021/icon-general_excellence-black_copy_3.svg"
                        alt="icon"
                      />
                    </div>

                    <div className="application__mic--why_apply-grid-entry-content">
                      <h3>Credibility</h3>

                      <span>
                        Gain the <em>Fast Company</em> stamp of approval for
                        creating a truly breakthrough technology
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="application__mic--eligibility">
                <h2>Eligibility</h2>

                <p>
                  Organizations may apply under 51 industry categories and must
                  demonstrate how their innovations from the past year have
                  impacted their business, their industry, and the broader
                  culture. Companies and nonprofits of all sizes will be
                  considered. For full application details, see the rules and
                  FAQs.
                </p>

                <div className="application__mic--eligibility-button">
                  <a href={header.link}>Apply Now</a>
                  <span>Final Deadline: September 17 ($995)</span>
                </div>
              </section>

              <section className="application__mic--categories">
                <h2>Categories</h2>

                <div className="application__mic--categories-grid">
                  <div className="application__mic--categories-grid-column">
                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Advertising</h3>
                      <span>
                        The agencies, technologies, and ideas advancing the
                        business of persuasion
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Architecture</h3>
                      <span>
                        Firms and commissions that are transforming the built
                        world
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Artificial Intelligence</h3>
                      <span>
                        Algorithmically powered products that are changing how
                        humans interact with computers
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Augmented and Virtual Reality</h3>
                      <span>
                        The firms creating the future of tech-powered immersive
                        entertainment and experiences
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Beauty</h3>
                      <span>The science and marketing of cosmetics</span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Biotech</h3>
                      <span>
                        The therapies and new solutions using biological science
                        to solve medical problems
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Branding</h3>
                      <span>
                        Marketers redefining and elevating the identities of
                        their companies or brands
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Consumer Electronics</h3>
                      <span>The new gadgets improving people’s lives</span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>
                        Consumer Goods <span>(New)</span>
                      </h3>
                      <span>
                        Pioneering products and brands that are transforming
                        consumers{"'"} daily lives
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>
                        Current Events <span>(New)</span>
                      </h3>
                      <span>
                        Special recognition for proactive, high-impact efforts
                        to address seminal events in 2021 such as pandemic
                        effects; income inequality; racial, gender, and
                        class-based divisions; and more
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Corporate Social Responsibility</h3>
                      <span>
                        Corporate initiatives that meaningfully make a positive
                        contribution to a company’s community and stakeholders
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Data Science</h3>
                      <span>
                        Companies building a competitive advantage through their
                        unique cache of intelligence
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Design</h3>
                      <span>
                        The companies and firms reshaping business through
                        industrial design, design thinking, and new user
                        experiences
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Dining and Hospitality</h3>
                      <span>
                        The restaurants and food service companies adapting to
                        changing customer demands
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Education</h3>
                      <span>New approaches to improving learning</span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Energy</h3>
                      <span>Novel initiatives that address climate change</span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Enterprise</h3>
                      <span>
                        Organizations offering tech and services that make other
                        businesses more efficient and effective
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Film and Television</h3>
                      <span>
                        The companies developing breakthrough programming—and
                        rethinking how content is marketed and released
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Finance</h3>
                      <span>
                        The products, technologies, and firms facilitating how
                        businesses manage their fiscal assets
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Food</h3>
                      <span>
                        Businesses that are producing the consumer goods,
                        systems, and agricultural technologies that are
                        transforming the way we eat
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Gaming</h3>
                      <span>
                        Cutting-edge play that entertains, enlightens, and
                        fosters new communities
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Health</h3>
                      <span>
                        The latest devices, services, and approaches to empower
                        patients
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Joint Ventures</h3>
                      <span>
                        Collaborations between two or more companies that
                        achieve more together than either company could on its
                        own.
                      </span>
                    </div>
                  </div>

                  {/* <!-- COLUMN DIVIDE --> */}

                  <div className="application__mic--categories-grid-column">
                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Live Events</h3>
                      <span>
                        Bringing people together in real or virtual life to
                        create indelible, shared moments
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Manufacturing</h3>
                      <span>
                        The facilities reinventing their processes to promote
                        flexibility, efficiency, and worker well-being
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Media</h3>
                      <span>
                        The businesses inventing or reinventing the future of
                        news
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>
                        Medical Devices <span>(New)</span>
                      </h3>
                      <span>
                        Hardware and gadgets that are changing how healthcare is
                        delivered
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>
                        Medicines and Therapeutics <span>(New)</span>
                      </h3>
                      <span>
                        Advances in treatments, vaccines, and drugs that help
                        people live longer, healthier lives
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Music</h3>
                      <span>
                        The artists, labels, streamers, promoters, and anyone
                        else making beautiful noise
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Not-for-Profit</h3>
                      <span>Fashioning the future of philanthropy</span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>
                        Personal Finance <span>(New)</span>
                      </h3>
                      <span>
                        The services powering wealth-building opportunities for
                        everyone
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Retail</h3>
                      <span>
                        Fresh approaches to selling goods and services
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Robotics</h3>
                      <span>
                        The companies finding creative ways of integrating
                        robotics into our lives and our work
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Security</h3>
                      <span>
                        Keeping people and companies safe from the new digital
                        warfare
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Social Good</h3>
                      <span>
                        For-profit companies doing their part to make the world
                        a better place
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Social Media</h3>
                      <span>
                        Daring strategies and new platforms for meeting people
                        where they live
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Space</h3>
                      <span>
                        The startups and stalwarts commercializing the final
                        frontier
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Sports</h3>
                      <span>
                        The teams, leagues, products, and off-the-field
                        all-stars scoring in the business of play
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Style</h3>
                      <span>Fashioning the future of how we dress</span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Transportation</h3>
                      <span>
                        Who’s driving new mobility solutions and clean
                        alternatives to traditional conveyances
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Travel</h3>
                      <span>
                        The businesses enabling new ways to explore the world
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Urban Development/Real Estate</h3>
                      <span>
                        The landscapes, properties, and thoughtful initiatives
                        defining how we live today
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Video</h3>
                      <span>
                        The players designing new platforms and novel ways to
                        consume media
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Wellness</h3>
                      <span>
                        The products and services redefining fitness and
                        self-care
                      </span>
                    </div>

                    <div className="application__mic--categories-grid-column-entry">
                      <h3>Workplace</h3>
                      <span>
                        Companies that have adopted services, policies, and
                        programs that fulfill their employees’ needs—and make
                        them happier
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="application__mic--regions">
                <div className="application__mic--regions-grid">
                  <div className="application__mic--regions-grid-column">
                    <div className="application__mic--regions-grid-column-entry">
                      <h3>Asia-Pacific</h3>
                      <span>
                        Companies headquartered in the Asia-Pacific whose
                        innovations embody the best ideals of the region and/or
                        work to solve problems inherent to the area
                      </span>
                    </div>

                    <div className="application__mic--regions-grid-column-entry">
                      <h3>Europe, Middle East, and Africa</h3>
                      <span>
                        Companies headquartered in EMEA whose innovations embody
                        the best ideals of the region and/or work to solve
                        problems inherent to the area
                      </span>
                    </div>
                  </div>

                  {/* <!-- COLUMN DIVIDE --> */}

                  <div className="application__mic--regions-grid-column">
                    <div className="application__mic--regions-grid-column-entry">
                      <h3>Latin America</h3>
                      <span>
                        Companies headquartered in Latin America whose
                        innovations embody the best ideals of the region and/or
                        work to solve problems inherent to the area
                      </span>
                    </div>

                    <div className="application__mic--regions-grid-column-entry">
                      <h3>North America</h3>
                      <span>
                        Companies headquartered in North America whose
                        innovations embody the best ideals of the region and/or
                        work to solve problems inherent to the area
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="application__mic--sizes">
                <div className="application__mic--sizes-grid">
                  <div className="application__mic--sizes-grid-column">
                    <div className="application__mic--sizes-grid-column-entry">
                      <h3>
                        Small and Mighty: Under 10 Employees <span>(New)</span>
                      </h3>
                      <span>
                        Organizations with less than 10 employees but big ideas
                        that put them at the vanguard of the next generation of
                        innovators
                      </span>
                    </div>
                  </div>

                  {/* <!-- COLUMN DIVIDE --> */}

                  <div className="application__mic--sizes-grid-column">
                    <div className="application__mic--sizes-grid-column-entry">
                      <h3>
                        Small and Mighty: 10-100 Employees <span>(New)</span>
                      </h3>
                      <span>
                        Organizations who have between 10 and 100 employees with
                        big ideas that put them at the vanguard of the next
                        generation of innovators
                      </span>
                    </div>
                  </div>
                </div>

                <div className="application__mic--sizes-button">
                  <a href={header.link}>Apply Now</a>
                  <span>Final Deadline: September 17 ($995)</span>
                </div>
              </section>
            </main>
          </article>
        </div>
      </div>
    </Fragment>
  );
}

MICApplication.propTypes = {
  header: PropTypes.shape({}).isRequired
};
